import { render, staticRenderFns } from "./speedTest.vue?vue&type=template&id=4a2da4e2&scoped=true"
import script from "./speedTest.vue?vue&type=script&lang=js"
export * from "./speedTest.vue?vue&type=script&lang=js"
import style0 from "./speedTest.vue?vue&type=style&index=0&id=4a2da4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2da4e2",
  null
  
)

export default component.exports